document.addEventListener('DOMContentLoaded', function() {
  
  // Map custom classes to AOS animations
  const animationMap = {
    'animate-fade-up': 'fade-up',
    'animate-fade-down': 'fade-down',
    'animate-fade-left': 'fade-left',
    'animate-fade-right': 'fade-right',
    'animate-zoom-in': 'zoom-in',
    'animate-zoom-out': 'zoom-out',
    'animate-slide-up': 'slide-up',
    'animate-slide-down': 'slide-down',
    'animate-flip-left': 'flip-left',
    'animate-flip-right': 'flip-right'
  };
  
  // Apply animations based on classes
  Object.keys(animationMap).forEach(function(className) {
    document.querySelectorAll('.' + className).forEach(function(element) {
      element.setAttribute('data-aos', animationMap[className]);
      element.setAttribute('data-aos-duration', '1000');
      element.setAttribute('data-aos-once', 'true');
    });
  });
  
  // Initialize AOS
  AOS.init({
    duration: 1000,
    once: true,
    offset: 100
  });
});